module.exports = __webpack_public_path__ + "assets/img/calignan.75e48784.jpg";